import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { reset, setProjects, setLoading } from './actions';

const projectsReducer = handleActions(
  {
    [setProjects.toString()]: (_, { payload: projects }) => projects,
    [reset.toString()]: () => []
  },
  []
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  projects: projectsReducer,
  loading: loadingReducer
});
